'use strict';

export const defaultState = () => ({
    isOpen: false
});

export const state = () => defaultState();

export const getters = {
    isOpen: state => state.isOpen
};

export const mutations = {
    TOGGLE_IS_OPEN(state) {
        state.isOpen = !state.isOpen;
    }
};

export const actions = {
    sendMessage({ state, dispatch }, message) {
        if (!state.isOpen) {
            dispatch('toggleChat');
        }

        window.setTimeout(() => {
            const chat = document.querySelector('#ai_chatbot_iframe');

            if (chat) {
                chat.contentWindow.postMessage(
                    `ai_chatbot:message:${message}`,
                    '*'
                );
            }
        }, 0);
    },

    toggleChat({ commit, state }) {
        commit('TOGGLE_IS_OPEN');

        const wizychat = document.querySelector('wizychat');

        if (wizychat) {
            wizychat.classList.toggle('chatbot-open');
        }

        if (!state.isOpen) {
            window.postMessage('ai_chatbot:open', '*');
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
